export default "__VITE_ASSET__FNcgoQuC__"